import { combineReducers } from "redux";
import roleReducer from "./roleReducer"
import appStateReducer from "./appStateReducer"
import sideMenuStateReducer from "./sideMenuStateReducer";
import trainingStateReducer from "./trainingStateReducer";
import navStateReducer from "./navStateReducer";
import inventoryStateReducer from "./inventoryStateReducer";
import loadingStateReducer from "./loadingStateReducer";


const reducers = combineReducers({
    role: roleReducer,
    appState: appStateReducer,
    sideMenuState: sideMenuStateReducer,
    trainingState: trainingStateReducer,
    navState: navStateReducer,
    inventoryState: inventoryStateReducer,
    loadingState: loadingStateReducer
})

export default reducers
export type State = ReturnType<typeof reducers>